<template>
  <div>
    <v-text-field
      v-model="searchQuery"
      dense
      clearable
      hide-details
      prepend-inner-icon="mdi-magnify"
      :placeholder="placeholder"
      class="mb-4"
      :style="{ width }"
    />
    <slot :filtered-items="filteredItems" />
  </div>
</template>

<script>
import { DraggableShowHideDialog } from '@/modules/shared/domain/DraggableShowHideDialog'

export default {
  name: "ColumnFilter",
  props: {
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Filter columns",
    },
    width: {
      type: String,
      default: "fit-content",
    },
  },
  data() {
    return {
      searchQuery: "",
      draggableShowHideDialog: null,
    };
  },
  watch: {
    items: {
      handler(newItems) {
        if (this.draggableShowHideDialog) {
          this.draggableShowHideDialog.updateOriginalItemsList(newItems);
        }
      },
      immediate: true,
    },
  },
  computed: {
    filteredItems() {
      return this.draggableShowHideDialog
        ? this.draggableShowHideDialog.filterItemsByQuery(this.searchQuery)
        : this.items;
    },
  },
  created() {
    this.draggableShowHideDialog = new DraggableShowHideDialog(this.items);
  },
};
</script>
